import styles from "./ProductView.module.css";

import ProductImage from "@/components/ProductImage";
import CopyToClipBoard from "@/components/CopyToClipboard/CopyToClipboard";
import LimitLines from "@/components/LimitLines";
import { FbaBatchItem } from "@/contexts/ShipmentContext";
import Tooltip, { TooltipProps } from "@/components/Tooltip";
import Flex from "@/components/Flex/Flex";
import { productConditionToString } from "../../utils";

export type ProductViewProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  item: FbaBatchItem;
  quantity: number;
  showAsin?: boolean;
  showCondition?: boolean;
  showSku?: boolean;
  small?: boolean;
  lines?: number;
  content1?: React.ReactNode;
  content2?: React.ReactNode;
  content3?: React.ReactNode;
  tooltipProps?: Partial<TooltipProps>;
  overrideFlexGapForDetails?: string;
};

export default function ProductView({
  item,
  quantity,
  showAsin = true,
  showCondition = true,
  showSku = true,
  small = false,
  lines,
  content1,
  content2,
  content3,
  tooltipProps,
  className,
  overrideFlexGapForDetails,
  ...rest
}: ProductViewProps) {
  return (
    <div className={`${styles.rowContainer} ${className ?? ""}`} {...rest}>
      <div className={styles.row}>
        <div className={styles.productImageContainer}>
          <ProductImage imageUrl={item.image} alt={item.name} size={small ? "44px" : "86px"} />
          <div className={`${styles.productImageQuantity} ${small ? styles.small : ""}`}>{quantity}</div>
        </div>
        <div className={styles.productDetailsContainer} style={overrideFlexGapForDetails ? {gap: overrideFlexGapForDetails + " !important"} : {}}>
          <div className={styles.productNameRow}>
            <Tooltip title={item.name} {...tooltipProps}>
              <LimitLines lines={lines}>
                <span className="strong">{item.name}</span>
              </LimitLines>
            </Tooltip>
            <span style={{flex: 1}} />
            {content1}
          </div>
          {showAsin && <Flex style={{alignSelf: "stretch"}}>
            <CopyToClipBoard value={item.asin} tooltipText="Copy ASIN">
              <div className={styles.productDetailContainer}>
                <p className="small-text weak">ASIN:</p>
                <p className="small-text strong">{item.asin}</p>
              </div>
            </CopyToClipBoard>
            <span style={{flex: 1}} />
            {content2}
          </Flex>}
          {showSku && <Flex style={{alignSelf: "stretch"}}>
            <CopyToClipBoard value={item.sku} tooltipText="Copy SKU">
              <div className={styles.productDetailContainer}>
                <p className="small-text weak">SKU:</p>
                <p className="small-text strong">{item.sku}</p>
              </div>
            </CopyToClipBoard>
            {!showAsin && content2}
          </Flex>}
          {showCondition && <div className={styles.productDetailContainer}>
            <p className="small-text weak">Condition:</p>
            <p className="small-text strong">{productConditionToString(item.condition)}</p>
          </div>}
          {content3}
        </div>
      </div>
    </div>
  );
}
